import { useCallback } from "react";

import Button from "ds/components/Button";
import useAnalytics from "hooks/useAnalytics";

import { showAiIntegrationFormDrawer } from "../FormDrawer";

type CreateIntegrationButtonProps = {
  onCreated?: () => void;
};

const AiCreateIntegrationButton = ({ onCreated }: CreateIntegrationButtonProps) => {
  const trackAnalytics = useAnalytics();

  const createIntegration = useCallback(() => {
    showAiIntegrationFormDrawer({ trackAnalytics, onCreated });
  }, [trackAnalytics, onCreated]);

  return (
    <Button variant="primary" onPress={createIntegration}>
      Set up integration
    </Button>
  );
};

export default AiCreateIntegrationButton;
